<button mat-fab class="palette-background-color-stronger-red" [ngClass]="deviceService.ifMobile('float-mobile').orElse('float')">
    <mat-icon>{{ icon }}</mat-icon>
</button>
